import React, { useState } from "react";
import ProjectGalleryMobile from "./ProjectGalleryMobile";
import ProjectGalleryDesktop from "./ProjectGalleryDesktop";


const ProjectGallery = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 600
  );

  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile ? <ProjectGalleryMobile /> : <ProjectGalleryDesktop />;
};

export default ProjectGallery;
